import React, { useContext } from 'react';
import { IWatchFullInfoContext, WatchFullInfoContext } from '../../../watchFullInfoState/watchFullInfoContext';
import Text from 'components/Text/Text';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import { CustomerField } from './CustomerField';
import { RestaurantField } from './RestaurantField';
import { Status } from './Status';
import { CreatedField } from './CreatedField';
import { UpdatedField } from './UpdatedField';
import style from './index.module.scss';

export const Info: React.FC = () => {
	const { watchFullInfo } = useContext<IWatchFullInfoContext>(WatchFullInfoContext);

	return (
		<div className={style.container} data-test="Info">
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="infoHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<FullInfoField label="serialNumberLabel" value={watchFullInfo?.serialNumber} />
				<CustomerField />
				<RestaurantField />
				<Status />
			</div>
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="updateInfoHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<CreatedField />
				<UpdatedField />
			</div>
		</div>
	);
};
